import { Component } from '@angular/core';

@Component({
  selector: 'app-timetable',
  imports: [],
  templateUrl: './timetable.component.html',
  styleUrl: './timetable.component.css',
})
export class TimetableComponent {}
